export enum TimelineStatus {
  ACTIVE = 'ACTIVE',
  REJECTED = 'REJECTED',
  DIVESTED = 'DIVESTED',
  ACQUIRED = 'ACQUIRED',
}
